const useShadowRoot = () => {
  const shadow = document.getElementById('contensis-blocks-preview-toolbar');
  const root = shadow?.shadowRoot;

  return root;
};

export default useShadowRoot;
